export default __webpack_public_path__ + "static/media/logo.f5263cf0.png";